import React from 'react'
import { RichTextInputContentProps, TiptapEditorProvider } from 'ra-input-rich-text'
import { EditorContent } from '@tiptap/react'
import { FormHelperText, styled } from '@mui/material'
import { InputHelperText } from 'ra-ui-materialui'

const Root = styled('div', {
  name: 'RaRichTextInput',
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  ['& .RaRichTextInput-editorContent']: {
    width: '100%',
    '& .ProseMirror': {
      backgroundColor: theme.palette.background.default,
      borderColor:
        theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)',
      borderRadius: theme.shape.borderRadius,
      borderStyle: 'solid',
      borderWidth: '1px',
      padding: theme.spacing(1),

      '&[contenteditable="false"], &[contenteditable="false"]:hover, &[contenteditable="false"]:focus':
        {
          backgroundColor: theme.palette.action.disabledBackground,
        },

      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
      '&:focus': {
        backgroundColor: theme.palette.background.default,
      },
      '& p': {
        margin: '0 0 1em 0',
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
  },
}))

const RichTextInputContent: React.FC<RichTextInputContentProps> = ({
  className,
  editor,
  error,
  helperText,
  id,
  isTouched,
  isSubmitted,
  invalid,
  toolbar,
}) => (
  <Root className={className}>
    <TiptapEditorProvider value={editor}>
      {toolbar}
      <EditorContent
        aria-labelledby={`${id}-label`}
        className={'RaRichTextInput-editorContent'}
        editor={editor}
      />
    </TiptapEditorProvider>
    <FormHelperText
      className={(isTouched || isSubmitted) && invalid ? 'ra-rich-text-input-error' : ''}
      error={(isTouched || isSubmitted) && invalid}
    >
      <InputHelperText
        touched={isTouched || isSubmitted}
        error={error?.message}
        helperText={helperText}
      />
    </FormHelperText>
  </Root>
)

export default RichTextInputContent
